<template>
    <div class="main">
        <c-panel title="ALMOXARIFADO — MOVIMENTAÇÃO DE ESTOQUE" titleIcon="fas fa-warehouse">

            <el-form label-position="top">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="6" v-if="ehSmed">
                        <el-form-item label="Instituição">
                            <el-select v-model="filtro.instituicao_id" placeholder="Todas" filterable clearable style="width:100%;" @change="onFiltrar">
                                <el-option v-for="i in $store.state.instituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="7">
                        <el-form-item label="Produto (filtro)">
                            <el-select v-model="filtro.produto_id" placeholder="Todos" filterable remote clearable :remote-method="buscarProduto" :loading="loadingProd" style="width:100%;" @change="onFiltrar">
                                <el-option v-for="p in produtosBusca" :key="p.id" :label="`${p.codigo} — ${p.nome}`" :value="p.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4">
                        <el-form-item label="Tipo (filtro)">
                            <el-select v-model="filtro.tipo" placeholder="Todos" clearable style="width:100%;" @change="onFiltrar">
                                <el-option v-for="t in tiposMov" :key="t.v" :label="t.l" :value="t.v"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="7" class="u-text-right" style="padding-top: 30px;">
                        <el-button type="success" plain icon="el-icon-bottom-left" @click="abrirEntrada">ENTRADA</el-button>
                        <el-button class="u-ml-10" type="warning" plain icon="el-icon-top-right" @click="abrirSaida">SAÍDA</el-button>
                        <el-button class="u-ml-10" type="info" plain icon="el-icon-sort" @click="abrirTransferencia">TRANSFERIR</el-button>
                    </el-col>
                </el-row>
                <el-row v-if="filtro.produto_id && instEfetiva">
                    <el-col :sm="24">
                        <strong>Saldo do produto selecionado: </strong>
                        <span style="font-size:15pt;">{{ saldo }} <small>{{ unidadeAtual() }}</small></span>
                    </el-col>
                </el-row>
            </el-form>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width:140px;">Data</th>
                            <th style="width:120px;">Tipo</th>
                            <th>Produto</th>
                            <th class="hidden-mobile">Instituição</th>
                            <th style="width:100px;" class="u-text-right">Qtd.</th>
                            <th class="hidden-mobile">Origem/Destino</th>
                            <th class="hidden-mobile">Lote/Doc</th>
                            <th style="width: 70px;" class="u-text-center">Detalhes</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="m in items" :key="m.id">
                            <td>{{ m.data_movimento | formatarDt }}</td>
                            <td><el-tag size="mini" :type="tagTipo(m.tipo)">{{ rotuloTipo(m.tipo) }}</el-tag></td>
                            <td>{{ m.produto ? m.produto.nome : '—' }}</td>
                            <td class="hidden-mobile">{{ m.instituicao ? m.instituicao.nome : '—' }}</td>
                            <td class="u-text-right">{{ Number(m.quantidade).toFixed(2) }}</td>
                            <td class="hidden-mobile">
                                <span v-if="[3,4].includes(m.tipo) && m.destino">{{ m.tipo === 3 ? '→' : '←' }} {{ m.destino.nome }}</span>
                                <span v-else>—</span>
                            </td>
                            <td class="hidden-mobile">{{ m.lote || m.documento || '—' }}</td>
                            <td class="u-text-center">
                                <el-button @click="verDetalhe(m)" title="Ver detalhes" type="primary" icon="el-icon-view" size="mini" plain></el-button>
                            </td>
                        </tr>
                        <tr v-if="!items.length"><td colspan="8" class="u-text-center" style="color:#909399;padding:15px;">Nenhuma movimentação encontrada.</td></tr>
                    </tbody>
                </table>

                <div v-if="!statusList" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>

                <el-row :gutter="10" v-if="statusList">
                    <el-col :xs="24" :sm="12"><div class="u-text-left u-mt-10">Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros.</div></el-col>
                    <el-col :xs="24" :sm="12" v-if="paginate.qtdItens > 30">
                        <div class="u-text-right">
                            <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens" @current-change="load" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                        </div>
                    </el-col>
                </el-row>
            </div>

            <!-- Detalhes da movimentação -->
            <el-dialog :close-on-click-modal="false" title="DETALHES DA MOVIMENTAÇÃO" :visible.sync="modalDetalhe" width="620px">
                <table v-if="detalhe" class="table">
                    <tbody>
                        <tr><th style="width: 42%;">Data/hora</th><td>{{ detalhe.data_movimento | formatarDt }}</td></tr>
                        <tr><th>Tipo</th><td><el-tag size="mini" :type="tagTipo(detalhe.tipo)">{{ rotuloTipo(detalhe.tipo) }}</el-tag></td></tr>
                        <tr><th>Produto</th><td>{{ detalhe.produto ? (detalhe.produto.codigo + ' — ' + detalhe.produto.nome) : '—' }}</td></tr>
                        <tr><th>Instituição</th><td>{{ detalhe.instituicao ? detalhe.instituicao.nome : '—' }}</td></tr>
                        <tr v-if="[3,4].includes(detalhe.tipo)">
                            <th>{{ detalhe.tipo === 3 ? 'Destino' : 'Origem' }}</th>
                            <td>{{ detalhe.destino ? detalhe.destino.nome : '—' }}</td>
                        </tr>
                        <tr><th>Quantidade</th><td>{{ Number(detalhe.quantidade).toFixed(3) }} {{ detalhe.produto ? detalhe.produto.unidade_medida : '' }}</td></tr>
                        <tr><th>Valor unitário</th><td>{{ detalhe.valor_unitario ? ('R$ ' + Number(detalhe.valor_unitario).toFixed(2)) : '—' }}</td></tr>
                        <tr><th>Lote</th><td>{{ detalhe.lote || '—' }}</td></tr>
                        <tr><th>Validade</th><td>{{ detalhe.validade ? $moment(detalhe.validade).format('DD/MM/YYYY') : '—' }}</td></tr>
                        <tr><th>Documento (NF/Req.)</th><td>{{ detalhe.documento || '—' }}</td></tr>
                        <tr><th>Observação</th><td>{{ detalhe.observacao || '—' }}</td></tr>
                    </tbody>
                </table>
                <span slot="footer">
                    <el-button @click="modalDetalhe = false">FECHAR</el-button>
                </span>
            </el-dialog>

            <!-- Dialogs -->
            <el-dialog title="Registrar ENTRADA" :visible.sync="modalEntradaVisivel" width="70%">
                <el-form label-position="top" :model="formMov" class="u-mt-10">
                    <movimento-form :form="formMov" :produtos="produtosBusca" :eh-smed="ehSmed" :instituicoes="$store.state.instituicoes" @buscar-produto="buscarProduto"></movimento-form>
                </el-form>
                <span slot="footer">
                    <el-button @click="modalEntradaVisivel = false">CANCELAR</el-button>
                    <el-button class="u-ml-10" type="success" @click="registrar('entrada')">REGISTRAR ENTRADA</el-button>
                </span>
            </el-dialog>

            <el-dialog title="Registrar SAÍDA" :visible.sync="modalSaidaVisivel" width="70%">
                <el-form label-position="top" :model="formMov" class="u-mt-10">
                    <movimento-form :form="formMov" :produtos="produtosBusca" :eh-smed="ehSmed" :instituicoes="$store.state.instituicoes" @buscar-produto="buscarProduto"></movimento-form>
                </el-form>
                <span slot="footer">
                    <el-button @click="modalSaidaVisivel = false">CANCELAR</el-button>
                    <el-button class="u-ml-10" type="warning" @click="registrar('saida')">REGISTRAR SAÍDA</el-button>
                </span>
            </el-dialog>

            <el-dialog title="Transferência" :visible.sync="modalTransferVisivel" width="70%">
                <el-form label-position="top" :model="formMov" class="u-mt-10">
                    <movimento-form :form="formMov" :produtos="produtosBusca" :eh-smed="ehSmed" :instituicoes="$store.state.instituicoes" @buscar-produto="buscarProduto"></movimento-form>
                    <el-form-item label="Instituição destino">
                        <el-select v-model="formMov.instituicao_destino_id" filterable placeholder="Selecione a instituição destino" style="width:100%;">
                            <el-option v-for="i in $store.state.instituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <span slot="footer">
                    <el-button @click="modalTransferVisivel = false">CANCELAR</el-button>
                    <el-button class="u-ml-10" type="info" @click="registrar('transferir')">TRANSFERIR</el-button>
                </span>
            </el-dialog>

        </c-panel>
    </div>
</template>

<script>
import moment from 'moment'
import MovimentoForm from './movimento-form.vue'

export default {
    components: { MovimentoForm },
    filters: { formatarDt (v) { return v ? moment(v).format('DD/MM/YYYY HH:mm') : '' } },
    data () {
        return {
            statusList: false,
            loadingProd: false,
            produtosBusca: [],
            saldo: 0,
            tiposMov: [
                { v: 1, l: 'Entrada' }, { v: 2, l: 'Saída' },
                { v: 3, l: 'Transf. Saída' }, { v: 4, l: 'Transf. Entrada' }, { v: 5, l: 'Ajuste' }
            ],
            filtro: { instituicao_id: '', produto_id: '', tipo: '' },
            paginate: { page: 1, qtdItens: null, from: '', to: '' },
            items: [],
            modalEntradaVisivel: false, modalSaidaVisivel: false, modalTransferVisivel: false,
            modalDetalhe: false, detalhe: null,
            formMov: this.formVazio()
        }
    },
    computed: {
        // Perfis sem instituição pré-selecionada (SMED/consulta) escolhem no filtro/formulário.
        ehSmed () { return [4, 5, 6, 7, 8, 10].includes(Number(this.$store.state.user.tipo)) },
        // Instituição efetiva usada para saldo e para pré-preencher o formulário.
        instEfetiva () {
            if (this.ehSmed) return this.filtro.instituicao_id || null
            const i = this.$store.state.config.instituicao
            return i && i.id ? i.id : null
        }
    },
    mounted () {
        if (!this.ehSmed && this.$store.state.config.instituicao) {
            this.filtro.instituicao_id = this.$store.state.config.instituicao.id
        }
        this.load(1)
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        unidadeAtual () { const p = this.produtosBusca.find(x => x.id === this.filtro.produto_id); return p ? p.unidade_medida : '' },

        formVazio () {
            return {
                produto_id: null, quantidade: 1, lote: '', validade: null,
                documento: '', observacao: '',
                instituicao_id: null,
                instituicao_destino_id: null
            }
        },

        rotuloTipo (t) { return { 1: 'Entrada', 2: 'Saída', 3: 'Transf. Saída', 4: 'Transf. Entrada', 5: 'Ajuste' }[t] || '?' },
        tagTipo (t) { return { 1: 'success', 2: 'warning', 3: 'info', 4: 'info', 5: '' }[t] || '' },

        verDetalhe (m) {
            this.detalhe = m
            this.modalDetalhe = true
        },
        onFiltrar () {
            this.load(1)
            this.atualizarSaldo()
        },

        load (page) {
            this.paginate.page = page || 1
            this.statusList = false
            this.items = []
            const payload = {
                instituicao_id: this.filtro.instituicao_id || '',
                produto_id: this.filtro.produto_id || '',
                tipo: this.filtro.tipo || ''
            }
            this.$axios.post(`${this.baseUrl()}/api/almox-estoque/movimentos?page=${this.paginate.page}`, payload, this.$store.getters.getHeaderAuth)
                .then(r => {
                    this.items = r.data.data
                    this.paginate.qtdItens = r.data.total
                    this.paginate.from = r.data.from
                    this.paginate.to = r.data.to
                    this.statusList = true
                }).catch(e => { this.statusList = true; this.$store.commit('throwException', e) })
        },

        buscarProduto (q) {
            if (!q || q.length < 2) return
            this.loadingProd = true
            this.$axios.post(`${this.baseUrl()}/api/almox-produto/getAllPaginate`, { busca: q, situacao: true }, this.$store.getters.getHeaderAuth)
                .then(r => { this.produtosBusca = (r.data && r.data.data) ? r.data.data : []; this.loadingProd = false })
                .catch(() => { this.loadingProd = false })
        },

        atualizarSaldo () {
            this.saldo = 0
            if (!this.filtro.produto_id || !this.instEfetiva) return
            this.$axios.get(`${this.baseUrl()}/api/almox-estoque/saldo/${this.filtro.produto_id}/${this.instEfetiva}`, this.$store.getters.getHeaderAuth)
                .then(r => { this.saldo = (r.data && r.data.saldo !== undefined) ? r.data.saldo : (r.data || 0) })
                .catch(() => {})
        },

        abrirEntrada () { this.formMov = this.formVazio(); this.prepararForm(); this.modalEntradaVisivel = true },
        abrirSaida () { this.formMov = this.formVazio(); this.prepararForm(); this.modalSaidaVisivel = true },
        abrirTransferencia () { this.formMov = this.formVazio(); this.prepararForm(); this.modalTransferVisivel = true },

        // Pré-preenche o formulário com o contexto atual dos filtros (produto/instituição).
        prepararForm () {
            this.formMov.produto_id = this.filtro.produto_id || null
            this.formMov.instituicao_id = this.instEfetiva
        },

        registrar (acao) {
            if (!this.formMov.instituicao_id) {
                window.eventBus.$emit('alert', { msg: 'Selecione a instituição.', type: 'warning' })
                return
            }
            const endpoint = { entrada: 'entrada', saida: 'saida', transferir: 'transferir' }[acao]
            this.$axios.post(`${this.baseUrl()}/api/almox-estoque/${endpoint}`, this.formMov, this.$store.getters.getHeaderAuth).then(r => {
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                    return
                }
                window.eventBus.$emit('alert', { msg: 'Registrado.', type: 'success' })
                this.modalEntradaVisivel = false
                this.modalSaidaVisivel = false
                this.modalTransferVisivel = false
                // Para SMED, passa a exibir a instituição usada; recarrega a lista.
                if (this.ehSmed && this.formMov.instituicao_id) this.filtro.instituicao_id = this.formMov.instituicao_id
                this.load(1)
                this.atualizarSaldo()
            })
        }
    }
}
</script>
